module.exports = __webpack_public_path__ + "static/media/R5-D4.1a48d17f.jpg";